import { NavLink, useLocation } from 'react-router-dom';
import {
  Upload, Tags, BarChart3, Activity, FlaskConical,
  BookOpen, GitCompare, Settings, TrendingUp, Building2,
} from 'lucide-react';
import { useApp } from '../context/AppContext';

const navItems = [
  { to: '/signals', icon: BarChart3, label: 'Signals' },
  { to: '/flow', icon: Building2, label: 'Inst. Flow' },
  { to: '/upload', icon: Upload, label: 'Import' },
  { to: '/broker-tags', icon: Tags, label: 'Broker Tags' },
  { to: '/simulator', icon: FlaskConical, label: 'Simulator' },
  { to: '/trades', icon: BookOpen, label: 'Real Trades' },
  { to: '/comparison', icon: GitCompare, label: 'Comparison' },
  { to: '/settings', icon: Settings, label: 'Settings' },
];

export default function Sidebar() {
  const location = useLocation();
  const { signals } = useApp();
  const confirmedCount = signals.filter(s => s.myStage === 'CONFIRMED' || s.optStage === 'CONFIRMED').length;

  return (
    <aside
      data-testid="sidebar-nav"
      className="w-56 flex-shrink-0 bg-trading-surface border-r border-trading-border flex flex-col h-screen"
    >
      {/* Logo */}
      <div className="px-4 py-5 border-b border-trading-border">
        <div className="flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-trading-blue" />
          <span className="font-heading text-lg font-semibold tracking-tight text-trading-text">
            BrokerFlow
          </span>
        </div>
        <span className="text-[10px] uppercase tracking-[0.15em] text-trading-muted font-mono mt-1 block">
          V4 Intelligence
        </span>
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-3 overflow-y-auto">
        {navItems.map(item => {
          const isActive = location.pathname === item.to ||
            (item.to === '/signals' && location.pathname.startsWith('/stock/'));
          return (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, '-')}`}
              className={`flex items-center gap-3 px-4 py-2.5 text-sm transition-colors duration-150 ${
                isActive
                  ? 'text-trading-text bg-trading-elevated border-l-2 border-trading-blue'
                  : 'text-trading-muted hover:text-trading-text hover:bg-trading-elevated/50 border-l-2 border-transparent'
              }`}
            >
              <item.icon className="w-4 h-4 flex-shrink-0" />
              <span className="font-body">{item.label}</span>
              {item.to === '/signals' && confirmedCount > 0 && (
                <span className="ml-auto text-[10px] font-mono bg-trading-green/15 text-trading-green px-1.5 py-0.5 rounded-sm">
                  {confirmedCount}
                </span>
              )}
            </NavLink>
          );
        })}
      </nav>

      {/* Status bar */}
      <div className="px-4 py-3 border-t border-trading-border">
        <div className="flex items-center justify-between text-[10px] font-mono text-trading-muted">
          <span>{signals.length} stocks</span>
          <span className="flex items-center gap-1">
            <Activity className="w-3 h-3 text-trading-green" />
            Active
          </span>
        </div>
      </div>
    </aside>
  );
}
